import { FieldValues, FormProvider } from 'react-hook-form';

import { AModal } from 'components/shared/AModal';
import { IApiFlightTripEvent } from 'detailsv2/structure';

import cs from '../../index.module.css';
import { CustomSubmitHandler } from '../../types';
import { useEventModal } from '../../useEventModal';
import { FlightButtonsGroup } from './FlightButtonsGroup';
import { FlightForm } from './FlightForm';
import { useFlightModalContent } from './functions';

type Props = {
  tripEvent: IApiFlightTripEvent;
  onSubmit: CustomSubmitHandler<FieldValues>;
};

const FlightTripEventModalContent = (props: Props) => {
  const { res, modalHeader } = useEventModal({ tripEvent: props.tripEvent });
  const {
    activeItems,
    setActiveItems,
    activeTab,
    setActiveTab,
    isDisabled,
    organizedBy,
    methods,
    popover,
    onChangePage,
  } = useFlightModalContent(props.tripEvent);

  return (
    <AModal isOpen header={modalHeader} onClose={() => res.success(false)} isCloseOnEsc size="xlg">
      <FormProvider {...methods}>
        <form className={cs.form}>
          <FlightForm
            activeItems={activeItems}
            setActiveItems={setActiveItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isDisabled={isDisabled}
            organizedBy={organizedBy}
            tripEvent={props.tripEvent}
            popover={popover}
            onChangePage={onChangePage}
          />
          <FlightButtonsGroup
            activeTab={activeTab}
            activeItems={activeItems}
            isDisabled={isDisabled}
            tripEvent={props.tripEvent}
            onSubmit={props.onSubmit}
          />
        </form>
      </FormProvider>
    </AModal>
  );
};

export default FlightTripEventModalContent;
